// extracted by mini-css-extract-plugin
export default {"antModal":"AntModal_antModal__qRM3B"};